import { formatDistanceToNow } from "date-fns";
const getFormattedDistance = (date) => {
  // Check if the date is valid
  const parsedDate = new Date(date);
  if (isNaN(parsedDate)) {
    return "undailed";
  }
  return formatDistanceToNow(parsedDate);
};
export default getFormattedDistance;
